
import apiClient from "@/shared/services/api/apiClient";

export interface NotificationItem {
  id: string;
  recipientId: string;
  eventType: string;
  title: string;
  message: string;
  entityType: string | null;
  entityId: string | null;
  actorId: string | null;
  readAt: string | null;
  eventKey?: string | null;
  createdAt: string;
  updatedAt: string;
  jobId?: string | null;
}

export interface NotificationPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

interface NotificationListData {
  notifications: NotificationItem[];
  pagination: NotificationPagination;
}

interface UnreadCountData {
  unreadCount: number;
}

interface MarkAllReadData {
  updatedCount: number;
}

const notificationsApi = {
  async getNotifications(
    page = 1,
    limit = 20,
    unreadOnly = false
  ): Promise<NotificationListData> {
    const response = await apiClient.get("/notifications", {
      params: { page, limit, unreadOnly },
    });

    return response.data.data as NotificationListData;
  },

  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get("/notifications/unread-count");

    const data = response.data.data as UnreadCountData;
    return data.unreadCount;
  },

  async markAsRead(
    notificationId: string
  ): Promise<NotificationItem | null> {
    const response = await apiClient.patch(
      `/notifications/${notificationId}/read`
    );

    return response.data.data as NotificationItem | null;
  },

  async markAllAsRead(): Promise<number> {
    const response = await apiClient.patch("/notifications/read-all");

    const data = response.data.data as MarkAllReadData;
    return data.updatedCount;
  },
};

export default notificationsApi;
